<template>
<div :class="{'no-bg':nobg, 'overflow-hidden': overflowCss === 0}" class="cp-singlePage">
  <div :class="{'step0': step===0}" class="container">
    <slot />
  </div>
</div>
</template>

<script>
export default {
  name: 'SinglePageVue',
  props: {
    nobg: {
      default: false,
      type: Boolean
    },
    overflowCss: {
      default: 0,
      type: Number
    },
    step: {
      default: 0,
      type: Number
    }
  }
}
</script>
